import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../core/services/network-call.service';
import { HelpersService } from '../../core/services/helpers.service';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import * as proofOfAddressDocumentTypesActions from '../actions/proof-of-address-document-types.actions';
import { IStaticDataResponse } from '../models/static-data.model';

@Injectable()
export class StaticDataProofOfAddressDocumentTypesEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helpers: HelpersService
  ) {}

  loadProofOfAddressDocumentTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(proofOfAddressDocumentTypesActions.loadProofOfAddressDocumentTypes),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>('StaticData/ProofOfAddressDocumentTypes').pipe(
          map(response => proofOfAddressDocumentTypesActions.loadProofOfAddressDocumentTypesSuccess({ response })),
          catchError(error => {
            return of(proofOfAddressDocumentTypesActions.loadProofOfAddressDocumentTypesFailure({ error }));
          })
        )
      )
    )
  );
}
